<i18n>
    {
        "ru": {
            "headline": "Цена билета изменилась, нажмите еще раз чтобы продолжить"
        },
        "en": {
            "headline": "Ticket price has changed, click again to continue"
        }
    }
</i18n>

<template>
    <span :class="$style.headline">{{ $t("headline") }}.</span>
</template>

<script>
export default {
    name: "PriceChangedHeadline",
};
</script>

<style module>
.headline {
    font-size: 14px;
    display: block;
    text-align: center;
    margin-bottom: 12px;
    color: #ff0000;
}
</style>
